<template>
  <v-container
    id="livechat"
    fluid
    style="max-height: calc(100vh - 64px); overflow: hidden;position: relative; padding: 0"
  >
    <livechat-search :isUnlock="isUnlock" v-model="showSearch"></livechat-search>

    <v-layout>
      <v-flex shrink>
        <template v-if="$store.state.livechat.pageid">
          <livechat-pagelist
            :timestamp.sync="timestamp"
            :value="$store.state.livechat.pageid"
            @changePage="changePage"
          ></livechat-pagelist>
        </template>
      </v-flex>
      <v-flex v-if="!isUnlock" style="position:relative;">
        <div style="position: absolute; left: 0px;right: 0px;bottom: 0;top: 0;">
          <div
            style="color: black; z-index: 1;  top: 0; left: 0; right: 0; bottom: 0 "
            :style="{
              position: 'absolute',
              'background-color': '#ecececbd'
            }"
          >
            <v-layout fill-height column justify-center>
              <div
                class="text-xs-center mt-4"
                style="margin-bottom: 25px;"
                :style="{ 'margin-top': 0 + 'px' }"
              >
                <h3 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
                  {{ $t('Its time to upgrade."') }}
                </h3>
                <template v-if="selectedBot.pagetype != 'enterprise'">
                  <p style="text-shadow: rgb(80, 80, 80) 1px 1px 20px;">
                    {{ $t('Upgrade Your Plan to use livechat feature , only 999 THB/month') }}
                  </p>

                  <v-btn
                    depressed
                    style="margin-bottom:1.5em"
                    target="_blank"
                    href="https://m.me/361231620965547?ref=livechat"
                    small
                    color="primary"
                    >{{ $t('GET/CONTINUE PREMIUM') }}</v-btn
                  >
                </template>
              </div>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <template v-else>
        <v-flex style="border-right: 1px solid #eee; max-width: 250px">
          <div id="chattype">
            <template v-if="searchlist.length == 0 && !$route.query.userid">
              <livechat-tab
                :pageidSelect="pageidSelect"
                :newchatnotify="newchatnotify"
                @onsearch="showSearch = true"
                @clearAllUnread="clearAllUnread"
              ></livechat-tab>
            </template>
            <v-btn
              v-else-if="$route.query.userid"
              @click="clearSearchUserid"
              depressed
              color="grey lighten-3"
              style="border-radius: 0; min-width: 100%; height: 45px"
              class="ma-0 pa-0"
            >
              <span> <v-icon small>clear</v-icon> {{ $t('ยกเลิกการค้นหา') }} </span>
            </v-btn>
            <template v-else>
              <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
              <v-divider></v-divider>
            </template>
          </div>
          <div v-if="$store.state.livechat.app && !usersearching">
            <template v-if="$store.state.livechat.type == 'admin'">
              <keep-alive>
                <users
                  :timestamp.sync="timestamp"
                  :newchatnotify="newchatnotify"
                  :app="$store.state.livechat.app"
                  :line_tab="$store.state.livechat.line_tab"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'admin'"
                  @onSearch="onSearch"
                  @onClickUser="onClickUser"
                  @livechatnotiunread="createUnreadInterval"
                ></users>
              </keep-alive>
            </template>
            <template v-if="$store.state.livechat.type == 'bot'">
              <keep-alive>
                <users
                  :timestamp.sync="timestamp"
                  :newchatnotify="newchatnotify"
                  :app="$store.state.livechat.app"
                  :line_tab="$store.state.livechat.line_tab"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'bot'"
                  @onSearch="onSearch"
                  @onClickUser="onClickUser"
                  @livechatnotiunread="createUnreadInterval"
                ></users>
              </keep-alive>
            </template>
          </div>
        </v-flex>
        <v-flex style="border-right: 1px solid #eee; position: relative;">
          <template v-if="selectedUser">
            <chatbox
              @endSession="onEndSession"
              @openSession="onOpenSession"
              :key="selectedUser.userid || selectedUser.group_id"
              :app="selectedUser.app"
              ref="chatbox"
            ></chatbox>
          </template>
        </v-flex>
        <v-flex style="position: relative;max-width: 300px" fill-height>
          <template v-if="selectedUser">
            <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
          </template>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import Livechat from './Livechat.js'
export default {
  mixins: [Livechat]
}
</script>
<style>
.newnotifycount {
  height: 16px;
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  background-color: #ff6565;
  /* width: 15px; */
  font-size: 10px;
  color: white;

  padding: 0px 5px;
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue